<template lang="pug">
.transfer-tab(
  v-if="show"
  :class="computedTabClass"
  :style="computedBackgroundStyle"
)
  .tab-item(
    v-for="(tab, index) in tabs"
    :key="index"
    :class="getTabClass(index)"
    @click="handleTabClick(index, tab.tabKey)"
  )
    .tab-content
      .tab-title(
        :style="getTabTitleStyle(index)"
      ) {{tab.title}}
        img.tab-logo(
          :src="tab.logoImg"
          v-if="isShowLogo(tab)"
          :class="type === 3 && activeTabKey === ANCHOR_MAP.RIDE ? 'new-corner' : ''"
        )
      .sub-title(
        :style="getTabSubTitleStyle(index)"
        v-if="tab.subTitle && !isActive(index)"
      ) {{tab.subTitle}}
</template>

<script>
import { PropVersionMap, TAB_BACKGROUND_IMAGES } from '@/const/vip';
import { ANCHOR_MAP } from '../../consts';

export default {
  name: 'TransferTab',
  props: {
    // 是否显示组件
    show: {
      type: Boolean,
      default: true,
    },
    // 当前激活的tab的key
    activeTabKey: {
      type: String,
      default: '',
    },
    // tab配置数组
    tabs: {
      type: Array,
      default: () => [
        { title: '' },
        { title: '' },
      ],
    },
    // 是否在App环境
    isApp: {
      type: Boolean,
      default: null,
    },
    tabCode: {
      type: String,
      default: '',
    },
    // Tab类型
    // 1:超级会员tab
    // 2:单车/助力车tab
    // 3:顶端tab 骑行卡/超级会员
    type: {
      type: [Number, String],
      default: 1,
    },
  },
  inject: ['freeRightsVersion'],
  data() {
    return {
      ANCHOR_MAP,
    };
  },
  computed: {
    computedTabClass() {
      const classes = [];

      // 根据type添加对应的类名
      classes.push(`tab-type-${this.type}`);

      // 根据isApp属性添加类名
      if (this.isApp === false) {
        classes.push('not-app');
      } else if (this.isApp === true) {
        classes.push('is-app');
      }

      return classes.join(' ');
    },
    // 根据tab数量获取对应的图片数组
    tabImages() {
      const tabCount = this.tabs.length;
      const bg = this.tabs.map((item, index) => {
        const isFreeRights = [
          PropVersionMap.RIDE_STEADY_VERSION,
          PropVersionMap.RIDE_RADICAL_VERSION,
        ].includes(item.tabKey);
        const bgObj = isFreeRights
          ? TAB_BACKGROUND_IMAGES.freeRightsVip
          : TAB_BACKGROUND_IMAGES.vip;
        const img = bgObj[tabCount][index];
        return img || '';
      });
      return bg;
    },
    // 根据tab数量和当前选中的index返回对应的背景图片
    computedBackgroundStyle() {
      if (this.type === 1) {
        const images = this.tabImages;
        const activeIndex = this.getActiveIndex();

        // 如果是默认情况（非2或3个tab），使用单双数逻辑
        if (this.tabs.length !== 2 && this.tabs.length !== 3) {
          return { backgroundImage: `url(${images[activeIndex % 2]})` };
        }

        return { backgroundImage: `url(${images[activeIndex]})` };
      }
      if (this.type === 3) {
        let backgroundColor = this.activeTabKey === ANCHOR_MAP.RIDE ? '#014ED6' : '#9A7A5A';
        let color = this.activeTabKey === ANCHOR_MAP.RIDE ? '#fff' : '#372215';
        if (this.freeRightsVersion()) {
          backgroundColor = '#014ED6';
          color = '#fff';
        }
        return { backgroundColor, color };
      }
      return {};
    },
  },
  watch: {
    // 监听 tabImages 计算属性的变化，触发预加载
    tabImages: {
      handler(newImages) {
        if (newImages && newImages.length > 0) {
          this.preloadBackgroundImages(newImages);
        }
      },
      immediate: true, // 立即执行一次
    },
  },
  mounted() {
    // 组件挂载完成
  },
  methods: {
    // 预加载背景图片
    preloadBackgroundImages(imageUrls) {
      // 使用传入的图片数组进行预加载
      const urls = imageUrls || this.tabImages || [];

      urls.forEach((url) => {
        if (url) {
          const img = new Image();
          img.src = url;
        }
      });
    },
    isActive(index) {
      const tab = this.tabs[index];
      return tab && tab.tabKey === this.activeTabKey;
    },
    // 根据当前选中的tabKey获取对应的index
    getActiveIndex() {
      const index = this.tabs.findIndex((tab) => tab.tabKey === this.activeTabKey);
      return index >= 0 ? index : 0; // 如果没找到，默认返回0
    },
    getTabClass(index) {
      const classes = [];

      if (this.isActive(index)) {
        if (this.freeRightsVersion() || this.activeTabKey === ANCHOR_MAP.RIDE) {
          classes.push('free-rights-active');
        }
        classes.push('active');
      } else {
        classes.push('inactive');
      }

      return classes.join(' ');
    },
    handleTabClick(index, tabKey) {
      if (!this.isActive(index)) {
        this.$emit('change', { tabKey });
      }
    },
    // 获取tab标题的样式
    getTabTitleStyle() {
      return {};
    },
    getTabSubTitleStyle() {
      return {};
    },
    // 控制logo显示逻辑
    isShowLogo(tab) {
      if (!tab.logoImg) {
        return false;
      }
      if (this.tabs.length === 3) {
        return tab.tabKey === 'oneCentVip';
      }
      if (this.tabs.length === 2) {
        if (this.type === 3 && this.activeTabKey === ANCHOR_MAP.VIP) {
          return false;
        }
        return true;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.transfer-tab {
  display: flex;
  font-family: PingFangSC, sans-serif;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  align-items: center;

  .tab-item {
    position: relative;

    .tab-content {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      overflow: visible;

      .tab-title {
        display: flex;
        flex-direction: row;
        align-items: center;

        .tab-logo {
          height: 0.16rem;
          object-fit: contain;
          margin-left: 0.02rem;

          &.new-corner {
            height: 0.14rem;
            position: absolute;
            right: -0.1rem;
            top: -0.05rem;
          }
        }
      }

      .sub-title {
        font-size: 0.1rem;
      }
    }

    &.active {
      z-index: 2;
    }

    &.inactive {
      z-index: 1;
    }
  }

  // ========== Type 1 样式 (会员tab) ==========
  &.tab-type-1 {
    // transform: translateY(0.01rem);
    height: 0.42rem;
    // margin-top: 0.88rem;
    width: 100%;
    justify-content: center;

    // 非App环境下的margin-top调整
    &.not-app {
    }

    .tab-item {
      height: 0.42rem;
      border-radius: 0.16rem 0.16rem 0 0;
      flex: 1;

      &.active {
        .tab-title {
          font-size: 0.15rem;
          font-family: "PingFang SC", sans-serif;
          font-weight: 800;
          color: #242729;
          // background: linear-gradient(270deg, #242729 0%, #985727 100%);
          // -webkit-background-clip: text;
          // background-clip: text;
          // -webkit-text-fill-color: transparent;
        }

        .sub-title {
          color: #242729;
          font-size: 0.1rem;
        }
      }

      &.inactive {
        padding-top: 0.02rem;

        .tab-title {
          font-family: "PingFang SC", sans-serif;
          font-size: 0.12rem;
          font-weight: 500;
          color: #372215;
          height: 0.16rem;
          line-height: 0.16rem;
        }

        .sub-title {
          font-size: 0.1rem;
          height: 0.12rem;
          line-height: 0.12rem;
          color: rgba(125, 97, 48, 0.8);
        }
      }
    }
  }

  // ========== Type 2 样式 (单车/助力车tab) ==========
  &.tab-type-2 {
    height: 0.28rem;
    margin-left: 0.16rem;
    margin-top: 0.14rem;

    .tab-item {
      height: 100%;
      padding: 0.03rem 0.16rem;
      font-weight: 500;
      font-size: 0.16rem;
      line-height: 0.28rem;
      transition: transform 0.3s ease;

      // &:not-last-child {
      //   margin-right: 0.08rem;
      // }

      &.active {
        height: 100%;
        border-radius: 0.14rem;
        background: #2d8dff;
        color: #fff;

        .tab-title {

        }

        .sub-title {

        }
      }

      &.inactive {
        .tab-title {

        }

        .sub-title {

        }
      }
    }
  }

  // ========== Type 3 样式 (最顶端tab 骑行卡/超级会员)==========
  &.tab-type-3 {
    justify-content: center;
    height: 0.32rem;
    width: fit-content;
    margin: 0 auto;
    border-radius: 0.16rem;
    padding: 0 0.02rem;

    .tab-item {
      font-family: PingFang SC, sans-serif;
      font-weight: 500;
      font-size: 0.16rem;
      width: 1rem;
      height: 0.28rem;
      line-height: 0.28rem;
      text-align: center;

      &.active {
        border-radius: 0.15rem;
        background: #fff6e7;

        .tab-title {
          color: #372215;
        }
      }

      &.free-rights-active {
        border-radius: 0.15rem;
        background: rgba(255, 255, 255, 0.3);
        box-shadow: inset 0 0.01rem 0 0 rgba(255, 255, 255, 0.5);

        .tab-title {
          color: #fff;
        }

        .sub-title {

        }
      }

      &.inactive {
        .tab-title {
          color: #fff;
        }

        .sub-title {

        }
      }
    }
  }
}

// 保留原有的 free-rights-version 样式
.free-rights-version {
  .transfer-tab {
    &.tab-type-1 {
      .tab-item {
        &.active {
          .tab-title {
            background: linear-gradient(270deg, #003960 0%, #00539b 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }

        &.inactive {
          .tab-title {
            color: rgba(255, 255, 255, 0.8);
          }

          .sub-title {
            color: #96bfff;
          }
        }
      }
    }
  }
}
</style>
